import { useQuery } from '@tanstack/react-query';

import type { EnrichedPlanDetails } from '@ekhodealer/ekho-common';

import { useCurrentServicesProviderId } from '@common/hooks/useCurrentServicesProviderId';
import { apiClient } from '@config/server/apiClient';
import { planEndpoints } from '@config/server/apiEndpoints';
import { queries } from '@config/server/queryKeys';

/**
 * API functions for Plan Details operations
 */

export const getPlanDetails = async (servicesProviderId: string): Promise<EnrichedPlanDetails> => {
	const response = await apiClient.get<EnrichedPlanDetails>(
		planEndpoints.base(servicesProviderId),
	);
	return response.data;
};

/**
 * Hook for fetching plan details for a services provider
 */
export const useGetPlanDetails = () => {
	const servicesProviderId = useCurrentServicesProviderId();

	return useQuery({
		queryKey: queries.planDetails.details(servicesProviderId).queryKey,
		queryFn: () => getPlanDetails(servicesProviderId),
		enabled: Boolean(servicesProviderId),
		staleTime: 5 * 60 * 1000, // 5 minutes - plan details don't change frequently
	});
};
